const table_columns = [
  {
    label: 'B2B_TABLE.KEYS_COLUMN',
  },
  {
    label: 'B2B_TABLE.STATUS_COLUMN',
  },
  {
    label: 'B2B_TABLE.CREATION_DATE_COLUMN',
  },
  {
    label: 'B2B_TABLE.DEACTIVATE_COLUMN',
  },
];

const filters = [
  {
    label: 'B2B.ACTIVE_KEYS',
    value: true,
  },
  {
    label: 'B2B.INACTIVE_KEYS',
    value: false,
  },
];

export default {
  table_columns,
  filters,
};



// WEBPACK FOOTER //
// ./src/app/main/b2b/constants/b2b-constants.js